export async function shipmentCommentUploadUseCase(file, shipments_type, shipmentCommentRepository) {

    const result = await shipmentCommentRepository.upload_comments(file, shipments_type);
    
    // const validate = new shipmentCommentRepository.model(result);

    // if (!validate.isValid()) {
    //     throw new Error("Shipment comments upload inválido");
    // }

    return result;
}